import React, { useState } from 'react';
import { InlineText } from '@ui/molecules/inputs';
import { translate } from '@utils/i18n';
import { Label, Text } from '@ui';
const namespace = 'features.settings.calendar_settings';
const MIN_MONTHLY_LIMIT = 5000;
const MIN_WEEKLY_LIMIT = 3000;
const MAX_LIMIT = 50000;
const MIN_DAY_MAX_EVENTS = 1;
const MAX_DAY_MAX_EVENTS = 20;
export function CalendarVisitLimits({ optimizationEnabled, isUpdating, savedMonthLimit, savedWeekLimit, savedDayMaxEvents, onCommitLimits }) {
    const [monthKey, setMonthKey] = useState(0);
    const [weekKey, setWeekKey] = useState(0);
    const [dayMaxKey, setDayMaxKey] = useState(0);
    const disabled = !optimizationEnabled || isUpdating;
    const validateAndCommit = (value, which, saved) => {
        if (disabled)
            return;
        if (value === '') {
            if (which === 'month')
                setMonthKey((k) => k + 1);
            else if (which === 'week')
                setWeekKey((k) => k + 1);
            else
                setDayMaxKey((k) => k + 1);
            return;
        }
        const n = typeof value === 'number' ? value : parseFloat(String(value));
        if (which === 'dayMax') {
            if (Number.isNaN(n) || !Number.isInteger(n) || n < MIN_DAY_MAX_EVENTS || n > MAX_DAY_MAX_EVENTS) {
                setDayMaxKey((k) => k + 1);
                return;
            }
        }
        else {
            const minLimit = which === 'month' ? MIN_MONTHLY_LIMIT : MIN_WEEKLY_LIMIT;
            if (Number.isNaN(n) || !Number.isInteger(n) || n < minLimit || n > MAX_LIMIT) {
                if (which === 'month')
                    setMonthKey((k) => k + 1);
                else
                    setWeekKey((k) => k + 1);
                return;
            }
        }
        if (n === saved)
            return;
        if (which === 'month')
            void onCommitLimits({ month: n });
        else if (which === 'week')
            void onCommitLimits({ week: n });
        else
            void onCommitLimits({ dayMax: n });
    };
    return (React.createElement("section", { className: "calendar-settings-limits", "aria-labelledby": "calendar-visit-limits-heading" },
        React.createElement(Text, { id: "calendar-visit-limits-heading", variant: "medium" }, translate('visit_limits_heading', { namespace })),
        React.createElement("br", null),
        React.createElement(Text, { className: "calendar-settings-limits__hint", variant: "xx-small" }, translate('visit_limits_hint', { namespace })),
        React.createElement("div", { className: "calendar-settings-limits__fields" },
            React.createElement("div", { className: "calendar-settings-limits__field calendar-settings-limits__field--inline" },
                React.createElement(Label, { id: "calendar-month-limit-label", htmlFor: "calendar-month-visit-limit", className: "qmb-label calendar-settings-limits__field-label" }, translate('month_limit_label', { namespace })),
                React.createElement(InlineText, { key: monthKey, id: "calendar-month-visit-limit", variant: "number", numberValue: savedMonthLimit, disableEdit: disabled, allowDecimals: false, allowNegative: false, "aria-labelledby": "calendar-month-limit-label", onNumberChange: (value) => validateAndCommit(value, 'month', savedMonthLimit) })),
            React.createElement("div", { className: "calendar-settings-limits__field calendar-settings-limits__field--inline" },
                React.createElement(Label, { id: "calendar-week-limit-label", htmlFor: "calendar-week-visit-limit", className: "qmb-label calendar-settings-limits__field-label" }, translate('week_limit_label', { namespace })),
                React.createElement(InlineText, { key: weekKey, id: "calendar-week-visit-limit", variant: "number", numberValue: savedWeekLimit, disableEdit: disabled, allowDecimals: false, allowNegative: false, "aria-labelledby": "calendar-week-limit-label", onNumberChange: (value) => validateAndCommit(value, 'week', savedWeekLimit) })),
            React.createElement("div", { className: "calendar-settings-limits__field calendar-settings-limits__field--inline" },
                React.createElement(Label, { id: "calendar-day-max-events-label", htmlFor: "calendar-day-max-events", className: "qmb-label calendar-settings-limits__field-label" }, translate('day_max_events_label', { namespace })),
                React.createElement(InlineText, { key: dayMaxKey, id: "calendar-day-max-events", variant: "number", numberValue: savedDayMaxEvents, disableEdit: disabled, allowDecimals: false, allowNegative: false, "aria-labelledby": "calendar-day-max-events-label", onNumberChange: (value) => validateAndCommit(value, 'dayMax', savedDayMaxEvents) })))));
}
